export const labelTextStyles = {
  fontSize: 18,
  fontWeight: 300,
  letterSpacing: '0.3px',
  lineHeight: '28px',
};

export const limitTextStyles = props => ({
  color: props.limitMet ? props.theme.palette.error.dark : props.theme.palette.success.dark,
  margin: props.theme.spacing(0, 0, 0.5, 0),
});

export const twoPartyLabelStyles = theme => ({
  ...theme.typography.body2,
  color: theme.palette.text.primary,
});

export const twoPartyPendingStyles = theme => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  margin: theme.spacing(1, 0),
});

export const unlimitedTextStyles = theme => ({
  ...theme.typography.subtitle1,
  color: theme.palette.text.primary,
  paddingTop: 2,
});
